import { formatPortalDateTime, formatLastAccess } from './portalDateFormat';

export { formatLastAccess };

const PERMISSION_SUMMARY: { key: string; label: string }[] = [
  { key: 'view_services', label: 'servizi' },
  { key: 'request_quotes', label: 'preventivi' },
  { key: 'view_reports', label: 'report' }
];

// Solo la prima parola della frase risultante è maiuscola (es. "Servizi, preventivi"),
// indipendentemente da quale permesso capiti per primo nell'elenco. Le permissions su
// PartnerPortalAccess sono già un array di stringhe (normalizePartnerPermissions in
// partnerAuthService.ts), a differenza dell'oggetto usato dal portale collaboratore.
export function permissionsSummary(permissions: string[]): string {
  const active = PERMISSION_SUMMARY.filter((p) => permissions.includes(p.key)).map((p) => p.label);
  if (active.length === 0) return 'Nessun permesso attivo';
  const joined = active.join(', ');
  return joined.charAt(0).toUpperCase() + joined.slice(1);
}

export function formatCreatedAt(value: string): string {
  return formatPortalDateTime(value);
}

export function formatLockedUntil(value: string): string {
  return formatPortalDateTime(value);
}

export function isAccessLocked(access: { locked_until?: string }): boolean {
  return !!access.locked_until && new Date(access.locked_until) > new Date();
}
